export default __webpack_public_path__ + "static/media/goopter-pudubot-capabilities.a1cc47cf.png";